// extracted by mini-css-extract-plugin
module.exports = {"bord_bottom":"Login_bord_bottom__2oz14","entry":"Login_entry__1vE_A","bot_text":"Login_bot_text__2-78W","error":"Login_error__ybrj-"};